<template>
  <div
    class="item-box-content"
    style="position:relative;"
  >
    <el-row>
      <el-col :span="12">
        <p style="font-weight:bold;font-size:16px;">退货记录</p>
      </el-col>
      <el-col
        :span="12"
        style="text-align:right;"
      >
        <!-- retreatState合同是否可以发起退货 true可以 false 不可以 -->
        <el-button
          v-show="contractFrom ==='直备采购' && retreatState"
          type="primary"
          @click="salesReturn"
          plain
        >发起退货
        </el-button>
      </el-col>
    </el-row>
    <el-table
      border
      ref="tableRef"
      :data="salesReturnRecordList"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      max-height="378"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        show-overflow-tooltip
        label="退货编号"
      >
        <template slot-scope="scope">
          <div
            class="operation-font-color"
            @click="onEdit(scope.row)"
          >{{scope.row.retreatNumber}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="suName"
        label="供应商名称"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="retreatType"
        label="售后类型"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="retreatProductAll"
        label="退货产品价值"
      >
        <template slot-scope="scope">
          <div>{{scope.row.retreatProductAll|priceFilterNum}}</div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="confiscateAll"
        label="罚没费用"
      >
        <template slot-scope="scope">
          <div>{{scope.row.confiscateAll|priceFilterNum}}</div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="state"
        label="退货状态"
      >
        <template slot-scope="scope">
          <div>{{state[scope.row.state-1]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="createDate"
        label="申请时间"
      >
        <template slot-scope="scope">
          <div>{{scope.row.createDate | dateFilter}}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  querySaleByPcbId
} from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'

export default {
  data () {
    return {
      state: ['审核中', '审核不通过', '退货中', '已完成'], // 退货状态
      retreatState: false,
      contractFrom: '',
      maintenanceRecordList: [
        {
          code: 'HN-999-000',
          state: '已发货',
          outOrderCode: 'Ch-000-0000'
        },
        {
          code: 'HN-999-000',
          state: '待发货',
          outOrderCode: 'Ch-000-0000'
        }],
      loadingTable: false,
      salesReturnRecordList: []
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    onEdit (row) {
      // this.$router.push({ name: 'afterSaleReturn', query: { pcbId: this.$route.query.pcbId } })
      this.$router.push({
        name: 'salesReturnDetail',
        query: {
          pcbId: this.$route.query.pcbId,
          pcrId: row.id
        }
      })
    },
    getList () {
      querySaleByPcbId(this.$route.query.pcbId)
        .then(res => {
          if (res.data.code === 200) {
            this.salesReturnRecordList = res.data.obj.purchaseContractRetreatAllVoList
            this.contractFrom = res.data.obj.purchaseContractBasesVo.contractFrom
            this.retreatState = res.data.obj.retreatState
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 发起退货
    salesReturn () {
      this.$router.push({
        name: 'afterSaleReturn',
        query: { pcbId: this.$route.query.pcbId }
      })
    }
  },

  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
